import(/* webpackMode: "eager" */ "/app/node_modules/@dpa/ritm-pulse/style.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/reset-css/reset.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/normalize.css/normalize.css");
;
import(/* webpackMode: "eager", webpackExports: ["StyledComponentsRegistry"] */ "/app/src/app/registry.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/styles/globals.css");
